'use client'

import React from 'react'
import mermaid from 'mermaid'
import {isMobile} from 'react-device-detect'
import dynamic from 'next/dynamic'
import {css, useTheme} from '@emotion/react'

import useFullScreenFeature from '../../../../hooks/useFullScreenFeature'
import DataExportControl from '../../../../components/modules/DataExportControl'
import InputResultPanelLayout from '../../../../components/layouts/InputResultPanelLayout'
import TextEditor from '../../../../components/modules/TextEditor'


const ChartView = dynamic(() => import('./ChartView'), {ssr: false})

export default function MermaidEditor() {
  const theme = useTheme()
  const styles = {
    top: css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `,

    resultControl: css`
      display: flex;
      justify-content: flex-end;
    `,

    imageArea: css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background-color: ${theme.palette.surface.main};

      border-color: ${theme.palette.primary.main};
      border-width: 2px;
      border-radius: 8px;
      border-style: dashed;

      display: flex;
      justify-content: center;
      align-items: center;
    `,

    bottomControlBar: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      height: 36px;
    `,
  }

  const [textInput, setTextInput] = React.useState(`flowchart TB
    c1-->a2
    subgraph one
    a1-->a2
    end
    subgraph two
    b1-->b2
    end
    subgraph three
    c1-->c2
    end
    one --> two
    three --> two
    two --> c2`)
  const onTextInputChange = (textInput) => {
    setTextInput(textInput)
  }

  const generateDownloadData = async () => {
    let graph = await mermaid.render('graphDiv', textInput)
    return '<?xml version="1.0" standalone="no"?>\r\n' + graph.svg
  }

  const [invalidInput, setInvalidInput] = React.useState(false)
  React.useEffect(() => {
    (async function () {
      setInvalidInput(!(await mermaid.parse(textInput, {suppressErrors: true})))
    })()
  }, [textInput])

  const [ResultFullScreenButton, ResultFullScreenContainer] = useFullScreenFeature()

  return (
    <InputResultPanelLayout
      inputContent={(
        <TextEditor
          id="text-input"
          value={textInput}
          onChange={onTextInputChange}
          autoFocus={true}
        />
      )}

      resultControl={(
        !isMobile && <div css={styles.resultControl}>
          <ResultFullScreenButton/>
        </div>
      )}
      resultContent={(
        <ResultFullScreenContainer css={styles.imageArea}>
          <ChartView chart={textInput}/>
        </ResultFullScreenContainer>
      )}

      resultBottom={(
        <div css={styles.bottomControlBar}>
          <DataExportControl
            disabled={!textInput || invalidInput}
            data={generateDownloadData}

            downloadButtonId={'download-button'}
            downloadFileExt={'.svg'}
          />
        </div>
      )}
    />
  )
}

